import { ISkeletonField } from "common/skeleton";

export const formSkeleton: ISkeletonField[][] = [
  // Row 1
  [
    { type: "input", span: 24 },
  ],
  // Row 2
  [
    { type: "input", span: 24 },
  ],
  [
    { type: "input", span: 24 },
  ],
  [
    { type: "input", span: 24 },
  ],
  [
    { type: "input", span: 24 },
  ],
  [
    { type: "input", span: 24 },
  ],
  [
    { type: "input", span: 24 },
  ],
];

export const SPACE_ERROR_MESSAGES = {
  CREATE_ERROR: "There was an issue while creating the space.",
  UPDATE_ERROR: "There was an issue while updating the space.",
};